<template>
  <!--收据管理（领用）审批-->
  <div style="width: 100%;padding-top: 60px">
    <div style="position: fixed;top: 0;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="收据详情" name="1">
        <van-field label="物业项目名称" v-model="inputForm.projectName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="收据类型" v-model="inputForm.typeName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="前缀" v-model="inputForm.prefix" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <div style="display: flex; align-items: center">
          <van-field label="编号" v-model="inputForm.startNumber" readonly></van-field>
          <span>—</span>
          <van-field v-model="inputForm.endNumber" readonly></van-field>
        </div>
        <van-field label="批次" v-model="inputForm.batch" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="领用人" v-mpdel="inputForm.recipientName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="领用时间" v-mpdel="inputForm.recipientTime" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="备注" v-mpdel="inputForm.remarks" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      </van-collapse-item>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {queryById, startFlow} from '../../api/finance/ReceiptManage'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "ReceiptManagement",
  data() {
    return {
      isshow: false,
      activeNames: ['1', '2', '3'],
      inputForm: {
        id: '',
        projectId: '',
        category: '',
        type: '',
        prefix: '',
        startNumber: '',
        endNumber: '',
        batch: '',
        recipientId: '',
        recipientTime: '',
        remarks: '',
        isDoTask: false,
        isLastTask: false,
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: ''
    }
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  components: {
    processRecord
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      queryById(id).then(({data}) => {
        this.inputForm = data
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status === '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>

</style>